import cn from 'classnames';
import { PanelLink } from '@creditflowresearch/uilib/PanelControl';
import { Label } from '@creditflowresearch/uilib/Badge/Label';
import Flex from '@creditflowresearch/uilib/Flex';

import styles from './sectionHeader.module.scss';

interface ISectionHeaderProps {
  label: string,
  badge: string,
  badgeColor: string,
  href?: string | { pathname: string, query: Record<string, string> },
  isActive?: boolean,
  dataTest?: string,
}

const SectionHeader = ({
  label,
  badge,
  badgeColor,
  href,
  isActive,
  dataTest = 'sectionItem',
}: ISectionHeaderProps) => {
  return (
    <Flex
      align="center"
      gap={ 8 }
      className={ cn(styles.header, { [styles.noLink]: !href, [styles.isActive]: isActive }) }
    >
      <Label className={ styles.badge } backgroundColor={ badgeColor }>
        { badge }
      </Label>
      { href ? (
        <PanelLink
          to={ href }
          className={ cn(styles.label, { [styles.isActive]: isActive }) }
          dataTest={ dataTest }
          isActive={ isActive }
        >
          { label }
        </PanelLink>
      ) : (
        <span className={ styles.labelText } data-test={ dataTest }>
          { label }
        </span>
      ) }
    </Flex>
  );
};

export default SectionHeader;
